






















import { Component, Vue, Prop } from "vue-property-decorator";
import StLoaderIcon from "@/components/basic/StLoaderIcon.vue";
import { UserStore } from "@/store/user-module";
import { successButtonColorClass } from "@/utlitities/color";

@Component({
  components: { StLoaderIcon },
  inheritAttrs: false
})
export default class StRoundButton extends Vue {
  @Prop() tooltipText!: string;
  @Prop() btnClass!: string;
  @Prop() loading!: boolean;
  @Prop() disabled!: boolean;
  @Prop() noMargin!: boolean;
  @Prop() tooltipOnBody!: boolean;
  @Prop() small!: boolean;
  @Prop() isInTrichSelect!: boolean;
  @Prop() crossed!: boolean;

  get tooltip() {
    if (!this.tooltipOnBody) {
      return {
        content: this.tooltipText
      };
    } else {
      return {
        content: this.tooltipText,
        boundariesElement: "body"
      };
    }
  }

  get successButtonColor() {
    return successButtonColorClass(UserStore.userSettings.successButtonColor);
  }

  click() {
    if (!this.loading && !this.disabled) {
      this.$emit("click");
    }
  }
}
